import { useState } from "react";
import { Clock, MessageCircle, Plane } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { useApi, waLink } from "@/lib/api";
import { ADDON_KEYS } from "@/components/site/BookingExtras";

const day = (n) => new Date(Date.now() + n * 86400000).toLocaleDateString("en-CA");
export const pickupTime = (ref = "") => {
  const m = ref.match(/\b([01]?\d|2[0-3])\s*[:.h]\s*([0-5]\d)\b/i);
  return m ? `${m[1].padStart(2, "0")}:${m[2]}` : null;
};
const toWa = (p) => { const d = p.replace(/\D/g, ""); return d.startsWith("0") ? "62" + d.slice(1) : d; };

export default function PickupList() {
  const { t } = useLang();
  const { data } = useApi("/admin/bookings");
  const [range, setRange] = useState("today");
  const today = day(0);
  const rows = (data || [])
    .filter((b) => ["car", "tour"].includes(b.item_type) && b.status !== "cancelled" && b.status !== "completed" && b.date >= today)
    .filter((b) => (range === "today" ? b.date === today : range === "tomorrow" ? b.date === day(1) : true))
    .map((b) => ({ ...b, time: pickupTime(b.transport_ref) }))
    .sort((a, b) => a.date.localeCompare(b.date) || (a.time || "99").localeCompare(b.time || "99"));
  return (
    <div data-testid="admin-pickup-list" className="mb-8 rounded-3xl border border-slate-200 bg-white p-6">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div><h2 className="flex items-center gap-2 text-xl font-bold"><Plane className="h-5 w-5 text-[#E11D48]" />{t("pk_title")}</h2><p className="mt-1 text-sm text-slate-500">{t("pk_sub")}</p></div>
        <div className="flex gap-1 rounded-full bg-slate-100 p-1">{["today", "tomorrow", "all"].map((r) => (
          <button key={r} data-testid={`admin-pickup-range-${r}`} onClick={() => setRange(r)} className={`rounded-full px-3 py-1.5 text-xs font-bold transition-colors ${range === r ? "bg-[#064E3B] text-white" : "text-slate-600 hover:bg-white"}`}>{t(`pk_${r}`)}</button>
        ))}</div>
      </div>
      {rows.length === 0 ? <p data-testid="admin-pickup-empty" className="mt-4 text-sm text-slate-500">{t("pk_empty")}</p> : (
        <ol className="mt-4 divide-y">{rows.map((b) => (
          <li key={b.id} data-testid={`admin-pickup-${b.code}`} className="flex flex-wrap items-center gap-4 py-3 text-sm">
            <span className={`flex w-24 shrink-0 items-center gap-1 font-mono font-bold ${b.time ? "text-[#064E3B]" : "text-slate-400"}`}><Clock className="h-4 w-4" />{b.time || "--:--"}</span>
            <div className="min-w-0 flex-1">
              <p className="font-semibold">{b.contact_name} · {b.item_name} <span className="text-xs font-normal text-slate-500">{b.date} · {b.code}</span></p>
              <p className="text-xs text-[#E11D48]">{b.transport_ref || "-"}{!b.time && b.transport_ref && ` · ${t("pk_notime")}`}</p>
              {b.addons?.length > 0 && <p className="text-xs text-sky-800">+ {b.addons.map((a) => t(ADDON_KEYS[a])).join(", ")}</p>}
            </div>
            <a href={waLink(toWa(b.phone), `${b.code} · ${b.transport_ref || ""}`)} target="_blank" rel="noreferrer" data-testid={`admin-pickup-wa-${b.code}`} className="inline-flex items-center gap-1 rounded-full bg-[#25D366] px-3 py-1.5 text-xs font-bold text-white"><MessageCircle className="h-3.5 w-3.5" />{b.phone}</a>
          </li>
        ))}</ol>
      )}
    </div>
  );
}
